const actionName = 'ExamineMap';

const notification = () => null;

const executeSideEffects = context => {
  const { party } = context;
  const { history } = party;

  history.add({ action: actionName, result: { success: true } }, context);

  return {
    notification: notification()
  };
};

const examineMap = {
  title: 'Examine Map',
  // 'x' rather than 'm': underlineHotkey marks the first match, and 'm' would land on the one in
  // Examine. b/s/r/w/h/t/c are already spoken for elsewhere in town.
  hotkey: 'x',
  actionName,
  enabled: () => true,
  execute: context => {
    const { message, notification } = executeSideEffects(context);

    return { result: { message }, notification };
  }
};

export default examineMap;
